import { Navigate, useParams } from "react-router-dom";

/** Legacy quality route — stoffkartotek lives under HMS/KS. */
export const ChemicalInventoryView = () => {
  const { id } = useParams();
  return (
    <Navigate
      to={`/dashboard/hse-ks/risk/chemical-inventory/${id}`}
      replace
    />
  );
};
